import App from '../src/App';

const Home = () => <App />;

export default Home;
